import { combineReducers } from 'redux';
import { AppReducer } from './app/reducer';
import { LoginReducer } from './auth/reducer';
import { SessionReducer } from './session/reducer';
import { UserReducer } from './user/reducer';
import { AppState } from './app/types';
import { LoginState } from './auth/types';
import { SessionState } from './session/types';
import { UserState } from './user/types';
import { RegState } from './registration/types';
import { RegReducer } from './registration/reducer';
import { MembersState } from './members/types';
import { MembersReducer } from './members/reducer';
import { MemberState } from './member/types';
import { MemberReducer } from './member/reducer';
import { AlertsReducer } from './alerts/reducer';
import { AlectsState } from './alerts/types';
import { OrganisationUserState } from './organisation/types';
import { OrganisationUserReducer } from './organisation/reducer';
import {
  ImpersonateUserState,
  ReferralChannelsState,
  MapState,
  LodgeEnquiryState,
  AreaOfInterestState,
  ReferralState,
  DashboardState,
  WebhookState,
  AnnouncementState,
  ArcgisState,
  EmailsState,
  CLOState,
  AuthorisationState,
  WebLauncherLandingState,
  ResponseState,
  AutodeskState,
  TrackState,
  SafetyMessageAndLogoState,
  PaymentState
} from 'types';
import { IUserReducer } from './iuser/reducer';
import { ReferralChannelsReducer } from './channels/reducer';
import { LodgeEnquiryReducer } from './lodgeEnquiry/reducer';
import { EnquiryState } from './enquiries/types';
import { AreaOfInterestReducer } from './areaOfInterest/reducer';
import { EnquiresReducer } from './enquiries/reducer';
import { MapReducer } from './map/reducer';
import { ReportsState } from './reports/types';
import { ReportsReducer } from './reports/reducer';
import { ReferralsReducer } from './referrals/reducer';
import { DashboardReducer } from './dashboard/reducer';
import { EmergencyContactsReducer } from './emergencyContacts/reducer';
import { EmergencyContactsState } from './emergencyContacts/types';
import { WebhookReducer } from './webhook/reducer';
import { ArcgisReducer } from './arcgis/reducer';
import { AnnouncementReducer } from './announcement/reducer';
import { EmailsReducer } from './emails/reducer';
import { CLOReducer } from './clo/reducer';
import { ResponseReducer } from './response/reducer';
import { AuthorisationReducer } from './authorisation/reducer';
import { WebLauncherLandingReducer } from './webLauncherLanding/reducer';
import { SafetyMessageAndLogoReducer } from './safetyMessageAndLogo/reducer';
import { AutodeskReducer } from './autodesk/reducer';
import { TrackReducer } from './track/reducer';
import { MemberLookupState } from './bydaMemberLookup/types';
import { MemberLookupReducer } from './bydaMemberLookup/reducer';
import { BelState } from './bulkEnquiryLodgement/types';
import { BelReducer } from './bulkEnquiryLodgement/reducer';
import { PaymentReducer } from './payment/reducer';

export interface RootState {
  app: AppState;
  login: LoginState;
  reg: RegState;
  session: SessionState;
  userCache: UserState;
  membersCache: MembersState;
  memberCache: MemberState;
  impersonateUser: ImpersonateUserState;
  referralChannels: ReferralChannelsState;
  lodgeEnquiryCache: LodgeEnquiryState;
  enquiresCache: EnquiryState;
  mapCache: MapState;
  aoiCache: AreaOfInterestState;
  alertsCache: AlectsState;
  OrganisationUserCache: OrganisationUserState;
  reports: ReportsState | null;
  referralsCache: ReferralState;
  dashboardCache: DashboardState;
  emergencyContacts: EmergencyContactsState;
  webhookCache: WebhookState;
  arcgisCache: ArcgisState;
  announcementCache: AnnouncementState;
  emailCache: EmailsState;
  cloCache: CLOState;
  responseCache: ResponseState;
  authorisationCache: AuthorisationState;
  webLauncherLandingCache: WebLauncherLandingState;
  safetyMessageAndLogoCache: SafetyMessageAndLogoState;
  trackCache: TrackState;
  autodeskCache: AutodeskState;
  memberLookupCache: MemberLookupState;
  belCache: BelState;
  paymentCache: PaymentState;
}

const rootReducer = combineReducers({
  app: AppReducer,
  login: LoginReducer,
  reg: RegReducer,
  session: SessionReducer,
  userCache: UserReducer,
  membersCache: MembersReducer,
  memberCache: MemberReducer,
  impersonateUser: IUserReducer,
  referralChannels: ReferralChannelsReducer,
  lodgeEnquiryCache: LodgeEnquiryReducer,
  enquiresCache: EnquiresReducer,
  mapCache: MapReducer,
  alertsCache: AlertsReducer,
  OrganisationUserCache: OrganisationUserReducer,
  aoiCache: AreaOfInterestReducer,
  reports: ReportsReducer,
  referralsCache: ReferralsReducer,
  dashboardCache: DashboardReducer,
  emergencyContacts: EmergencyContactsReducer,
  webhookCache: WebhookReducer,
  arcgisCache: ArcgisReducer,
  announcementCache: AnnouncementReducer,
  emailCache: EmailsReducer,
  cloCache: CLOReducer,
  authorisationCache: AuthorisationReducer,
  webLauncherLandingCache: WebLauncherLandingReducer,
  responseCache: ResponseReducer,
  autodeskCache: AutodeskReducer,
  trackCache: TrackReducer,
  safetyMessageAndLogoCache: SafetyMessageAndLogoReducer,
  memberLookupCache: MemberLookupReducer,
  belCache: BelReducer,
  paymentCache: PaymentReducer
});

export default rootReducer;
